export const greyColors = {
  'white': '#FFFFFF',
  'grey-25': '#FAFAFA',
  'grey-50': '#F1F2F3',
  'grey-100': '#E3E5E7',
  'grey-200': '#D4D7DA',
  'grey-300': '#AAB0B6',
  'grey-400': '#8D959D',
  'grey-500': '#717B85',
  'grey-600': '#4F565D',
  'grey-700': '#444A50',
  'grey-800': '#2D3135',
  'grey-900': '#0B0C0D',
}

export const redColors = {
  'red-50': '#FEEAED',
  'red-100': '#FDD5DA',
  'red-200': '#FAABB6',
  'red-300': '#F88291',
  'red-400': '#F5586D',
  'red-500': '#F32E48',
  'red-600': '#C21930',
  'red-700': '#920C1D',
  'red-800': '#610C18',
  'red-900': '#310208',
}

export const greenColors = {
  'green-50': '#E8F8F4',
  'green-100': '#D0F1E9',
  'green-200': '#A1E3D2',
  'green-300': '#72D4BC',
  'green-400': '#43C6A5',
  'green-500': '#14B88F',
  'green-600': '#0D9371',
  'green-700': '#086E55',
  'green-800': '#044A38',
  'green-900': '#01251C',
}

export const limeColors = {
  'lime-50': '#F5FCF1',
  'lime-100': '#EBF8E2',
  'lime-200': '#D8F1C5',
  'lime-300': '#CAE8AB',
  'lime-400': '#B1E48B',
  'lime-500': '#9DDD6E',
  'lime-600': '#7CB155',
  'lime-700': '#5A853C',
  'lime-800': '#3B5825',
  'lime-900': '#1A2C0E',
}

export const blueColors = {
  'blue-50': '#EAF5FF',
  'blue-100': '#D4EAFF',
  'blue-200': '#A9D5FF',
  'blue-300': '#7FC1FF',
  'blue-400': '#54ACFF',
  'blue-500': '#2997FF',
  'blue-600': '#1D77CC',
  'blue-700': '#125899',
  'blue-800': '#093966',
  'blue-900': '#051C33',
}

export const darkblueColors = {
  'darkblue-50': '#E9F1FE',
  'darkblue-100': '#D4E3FC',
  'darkblue-200': '#A8C6FA',
  'darkblue-300': '#7DAAF7',
  'darkblue-400': '#518DF5',
  'darkblue-500': '#2671F2',
  'darkblue-600': '#1555C2',
  'darkblue-700': '#0C3D91',
  'darkblue-800': '#082861',
  'darkblue-900': '#021430',
}

export const goldColors = {
  'gold-50': '#FFF9EB',
  'gold-100': '#FFF3D6',
  'gold-200': '#FFE7AD',
  'gold-300': '#FFDA85',
  'gold-400': '#FFCE5C',
  'gold-500': '#FFC233',
  'gold-600': '#CC9A25',
  'gold-700': '#997218',
  'gold-800': '#664C0E',
  'gold-900': '#332606',
}

export const yellowColors = {
  'yellow-50': '#FFF6E9',
  'yellow-100': '#FFECD3',
  'yellow-200': '#FFD9A7',
  'yellow-300': '#FFC67C',
  'yellow-400': '#FFB350',
  'yellow-500': '#FFA024',
  'yellow-600': '#CC7D16',
  'yellow-700': '#995C0E',
  'yellow-800': '#663C05',
  'yellow-900': '#331E02',
}

export const orangeColors = {
  'orange-50': '#FFEFEB',
  'orange-100': '#FFDFD7',
  'orange-200': '#FFBEAE',
  'orange-300': '#FF9E86',
  'orange-400': '#FF7D5D',
  'orange-500': '#FF5D35',
  'orange-600': '#CC4423',
  'orange-700': '#993117',
  'orange-800': '#661E0C',
  'orange-900': '#330D04',
}

export const peachColors = {
  'peach-50': '#FFF5EF',
  'peach-100': '#FFEADF',
  'peach-200': '#FFD5BE',
  'peach-300': '#FFC09E',
  'peach-400': '#FFAB7D',
  'peach-500': '#FF965D',
  'peach-600': '#CC6C37',
  'peach-700': '#994A20',
  'peach-800': '#663113',
  'peach-900': '#331708',
}

export const indigoColors = {
  'indigo-50': '#ECECFF',
  'indigo-100': '#D8D8FF',
  'indigo-200': '#B1B1FF',
  'indigo-300': '#8B8BFF',
  'indigo-400': '#6464FF',
  'indigo-500': '#3D3DFF',
  'indigo-600': '#2B2BCC',
  'indigo-700': '#1A1A99',
  'indigo-800': '#0F0F66',
  'indigo-900': '#060633',
}

export const purpleColors = {
  'purple-50': '#F9EFF9',
  'purple-100': '#F2DFFF',
  'purple-200': '#E5BFFF',
  'purple-300': '#D9BFFF',
  'purple-400': '#CB7FFF',
  'purple-500': '#BE5FFF',
  'purple-600': '#913BCC',
  'purple-700': '#692399',
  'purple-800': '#430F66',
  'purple-900': '#210733',
}

export const pinkColors = {
  'pink-50': '#FFF0FF',
  'pink-100': '#FFE2FF',
  'pink-200': '#FFC5FF',
  'pink-300': '#FFA7FF',
  'pink-400': '#FF8AFF',
  'pink-500': '#FF6DFF',
  'pink-600': '#CC41CC',
  'pink-700': '#992B99',
  'pink-800': '#661A66',
  'pink-900': '#330B33',
}

export const baseColors = {
  ...greyColors,
  ...redColors,
  ...orangeColors,
  ...peachColors,
  ...yellowColors,
  ...goldColors,
  ...limeColors,
  ...greenColors,
  ...blueColors,
  ...darkblueColors,
  ...indigoColors,
  ...purpleColors,
  ...pinkColors,
}

export const mainThemeColors = {
  'brand': baseColors['orange-500'],
  'transactional': baseColors['blue-500'],
  'dataroom': baseColors['purple-500'],
  'electronicsafe': baseColors['indigo-500'],
}

export const functionalColors = {
  'success': baseColors['green-500'],
  'info': baseColors['darkblue-500'],
  'warning': baseColors['yellow-500'],
  'error': baseColors['red-500'],
}

export const extraColors = {
  'red': baseColors['red-500'],
  'orange': baseColors['orange-500'],
  'yellow': baseColors['yellow-500'],
  'green': baseColors['green-500'],
  'blue': baseColors['blue-500'],
  'darkBlue': baseColors['darkblue-500'],
  'indigo': baseColors['indigo-500'],
  'purple': baseColors['purple-500'],
  'pink': baseColors['pink-500'],
  'peach': baseColors['peach-500'],
  'lime': baseColors['lime-500'],
  'gold': baseColors['gold-500'],
}

export const premiumColors = {
  'premium': baseColors['gold-500'],
}

export const vuetifyOverrideColors = {
  'primary': baseColors['orange-500'],
}

export const aliasColors = {
  ...mainThemeColors,
  ...functionalColors,
  ...extraColors,
  ...premiumColors,
  ...vuetifyOverrideColors,
}

export const themeColors = {
  ...baseColors,
  ...aliasColors,
}

export type ThemeColors = keyof typeof themeColors
